<template>
    <div class="login-box" id="login">
        <h3>{{ $t('login.formHeadline') }}</h3>
        <p class="intro">{{ $t('login.formIntro') }}</p>
        <div class="login-box-body">
            <form @submit.prevent="login">
                <div class="form-group">
                    <input type="email" 
                           v-model="loginForm.email"  
                           name="email" 
                           class="col-md-12 col-form-label autofocus" 
                           :class="{'has-error': loginForm.errors.has('email')}"
                           autocomplete="username" 
                           required
                           :placeholder="$t('login.email')"
                           :pattern="email_pattern"
                           autofocus>
                    <span class="fa fa-envelope form-control-feedback symbol-input"></span>
                    <HasError :form="loginForm" field="email"></HasError>
                </div>
                <div class="form-group">
                    <input type="password" 
                           v-model="loginForm.password" 
                           name="password" 
                           class="col-md-12 col-form-label" 
                           :class="{'has-error': loginForm.errors.has('password')}"
                           autocomplete="current-password" 
                           :placeholder="$t('login.password')"
                           required>
                    <span class="fa fa-lock form-control-feedback symbol-input"></span>
                    <HasError :form="loginForm" field="password"></HasError>
                </div>
                <div class="col-xs-8">
                    <div class="icheck-primary mb-3">
                        <input type="checkbox" v-model="loginForm.remember"  name="remember" id="remember" true-value="1">
                        <label for="remember">{{ $t('login.remember_me') }}</label>
                    </div>
                </div>
                <div class="form-group">
                    <div class="">
                        <button type="submit" class="btn btn-primary btn-block slide-btn w-100" :disabled="loading">
                            {{ $t('login.sign_in') }}
                        </button>
                    </div>
                    <p>
                        <router-link :to="{name: 'register'}" class="btn btn-secondary btn-block text-center d-lg-block mt-3 slide-btn">
                            {{ $t('login.register_a_new_membership2') }}
                        </router-link>
                    </p>
                    <p>
                        <router-link :to="{name: 'password_reset'}" class="text-right d-block mt-3">
                            {{ $t('login.i_forgot_my_password') }}
                        </router-link>
                    </p>
                </div>
            </form>
        </div>
    </div>
    <div class="logo-band">
        <inline-svg src="/assets/images/payment_logos.svg" alt="Gizmorilla Logo" class="brand-image"></inline-svg>
    </div>
</template>
<script>   
    export default {
        name: 'Login',
        data(){
            return {
                loginForm: new Form({
                    email: '',
                    password: '',
                    lang: '',
                    remember: 0
                }),
                loading: false
            };
        }
        ,created(){

        }
        ,mounted() {
            
        }
        ,computed:{

        }
        ,methods: {
            login(){
                this.loading = true;
                console.log('login');
                this.loginForm.lang = window.langKey;
                this.loginForm.post('/login')
                .then(response => {
                    if(response.status === 204){
                        window.location.href='/home';
                    }
                }).catch(function (error) {

                });
                this.loading = false;
            }
        }
    }
</script>